import { Box, Button, ButtonGroup, Tooltip, Typography } from "@mui/material";
import { useNavigate, useParams } from "react-router-dom";
import { ISpykioContext } from "../../../../types/contract";
import { useTranslation } from "react-i18next";
import { useEffect } from "react";
import useHighlightedParagraphs from "../../../../hooks/useHighlightedParagraphs";

const RelevantSectionsSpykio = ({
  spykioContext,
}: {
  spykioContext?: ISpykioContext[];
}) => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const {
    highlightedParagraphIds,
    getHighlightedIds,
    setHighlightedIds,
    addHighlightedId,
    removeHighlightedId,
    clearHighlightedIds,
    isHighlighted,
    toggleHighlightedId,
    getHighlightedCount,
  } = useHighlightedParagraphs();

  const {
    clientId,
    contractId,
    documentId: documentIdFromParams,
    pageMode,
    status,
    folder,
  } = useParams();

  useEffect(() => {
    console.log("Highlighted Paragraph IDs:", highlightedParagraphIds);
  }, [highlightedParagraphIds]);

  const handleParagraphClick = (
    paragraphIds: string[],
    documentId?: string,
    contractId?: string
  ) => {
    setHighlightedIds(paragraphIds);

    if (documentId !== documentIdFromParams) {
      // If the documentId is different, we need to update the URL
      const newUrl = `/contract/${contractId}/document/${documentId}`;
      navigate(newUrl);

      return;
    }

    // setTimeout(() => {
    //   const element = document.getElementById(
    //     `highlight-ref-${paragraphIds[0]}`
    //   );

    //   if (element) {
    //     element.scrollIntoView({
    //       behavior: "smooth",
    //       block: "center",
    //     });
    //   }
    // }, 300);
  };

  if (
    !spykioContext ||
    spykioContext.length === 0 ||
    !Array.isArray(spykioContext) ||
    spykioContext.filter((context) => context?.relevantSections).length === 0
  ) {
    return <span />;
  }

  return (
    <Box
      py="5px"
      style={{
        display: "flex",
        flexDirection: "column",
        gap: 5,
        justifyContent: "flex-start",
      }}
    >
      {spykioContext?.map((context) => {
        return (
          <ButtonGroup
            orientation="vertical"
            fullWidth
            key={context.documentId}
            size="small"
          >
            {/* <Typography variant="subtitle1">{context.documentName}</Typography> */}
            {context?.relevantSections
              ?.filter(
                (section) =>
                  section?.relevanceScore && section.relevanceScore > 0.8
              )
              ?.map((section, i: number) => {
                return (
                  <Button
                    // href={`#${paragraph.id}`}
                    variant="text"
                    onClick={() =>
                      handleParagraphClick(
                        section.paragraphIds,
                        context.documentId,
                        context.contractId
                      )
                    }
                    disabled={
                      !section.paragraphIds || section.paragraphIds.length === 0
                    }
                    // startIcon={<SourceOutlined />}
                    fullWidth
                    sx={{
                      justifyContent: "flex-start",
                      textAlign: "left",
                      textTransform: "none",
                      color: "text.primary",
                      "&:hover": {
                        backgroundColor: "action.hover",
                      },
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        width: "100%",
                      }}
                    >
                      <Tooltip title={section.text} placement="left">
                        <Typography
                          variant="caption"
                          sx={{
                            whiteSpace: "wrap",
                            textOverflow: "ellipsis",
                            overflow: "hidden",
                            // only allow 2 lines
                            display: "-webkit-box",
                            WebkitLineClamp: 1,
                            WebkitBoxOrient: "vertical",
                          }}
                        >
                          {section.text}
                        </Typography>
                      </Tooltip>

                      {/* {section.relevanceScore && (
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "flex-end",
                        }}
                      >
                        <Typography
                          variant="caption"
                          sx={{ ml: 1, color: "text.secondary" }}
                        >
                          {t("Relevance score")}:{" "}
                          {Math.round(section.relevanceScore * 100)}%
                        </Typography>
                      </div>
                    )} */}
                    </div>
                  </Button>
                );
              })}
          </ButtonGroup>
        );
      })}
    </Box>
  );
};

export default RelevantSectionsSpykio;
